import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Fab,
  Tooltip,
  OutlinedInput,
  FormHelperText,
  FormGroup,
  CircularProgress,
  Checkbox,
  Box,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";

const KeyValueRow = (props) => {
  const removeKeyValue = (index) => {
    if (index > -1) {
      let temp = props.kvArr;
      temp.splice(index, 1);
      props.setKvArr(temp);

      let tempErr = props.kvErrorArr;
      tempErr.splice(index, 1);
      props.setKvErrorArr(tempErr);
      props.setTrig(!props.trig);
    }
  };
  return (
    <div className="key-value-row">
      <TextField
        label="Key"
        value={props.kvArr[props.index].key}
        error={props.kvErrorArr[props.index].key}
        helperText={props.kvErrorArr[props.index].key ? "Enter Key" : ""}
        onChange={(e) => {
          let temp_kvArr = props.kvArr;
          temp_kvArr[props.index].key = e.target.value;
          props.setKvArr(temp_kvArr);
          props.setTrig(!props.trig);
        }}
      />
      <TextField
        label="Value"
        value={props.kvArr[props.index].value}
        error={props.kvErrorArr[props.index].value}
        helperText={props.kvErrorArr[props.index].value ? "Enter Value" : ""}
        onChange={(e) => {
          let temp_kvArr = props.kvArr;
          temp_kvArr[props.index].value = e.target.value;
          props.setKvArr(temp_kvArr);
          props.setTrig(!props.trig);
        }}
      />
      <IconButton
        onClick={() => {
          removeKeyValue(props.index);
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

const FieldValueRow = (props) => {
  const [fieldType, setFieldType] = useState(
    props.kvArr[props.index].field_type
  );
  const removeKeyValue = (index) => {
    if (index > -1) {
      let temp = props.kvArr;
      temp.splice(index, 1);
      props.setKvArr(temp);

      let tempErr = props.kvErrorArr;
      tempErr.splice(index, 1);
      props.setKvErrorArr(tempErr);
      props.setTrig(!props.trig);
    }
  };
  switch (fieldType) {
    case "2":
      return (
        <div className="key-value-row">
          {/* <TextField
            label="Field"
            value={props.kvArr[props.index].field}
            error={props.kvErrorArr[props.index].field}
            helperText={
              props.kvErrorArr[props.index].field ? "Enter Field Name" : ""
            }
            onChange={(e) => {
              let temp_kvArr = props.kvArr;
              temp_kvArr[props.index].field = e.target.value;
              props.setKvArr(temp_kvArr);
              props.setTrig(!props.trig);
            }}
          /> */}
          <FormControl
            variant="filled"
            sx={{ minWidth: 220 }}
            error={props.kvErrorArr[props.index].field}
          >
            <InputLabel>Field</InputLabel>
            <Select
              value={props.kvArr[props.index].field}
              onChange={(e) => {
                let temp_kvArr = props.kvArr;
                temp_kvArr[props.index].field = e.target.value;
                let field_obj = props.dbTableFields.filter((obj, index) => {
                  return obj.name === e.target.value;
                })[0];
                temp_kvArr[props.index].field_type = field_obj.field_type;
                setFieldType(field_obj.field_type);
                if (field_obj.field_type === "2") {
                  temp_kvArr[props.index].value = false;
                } else {
                  temp_kvArr[props.index].value = "";
                }
                props.setKvArr(temp_kvArr);
                props.setTrig(!props.trig);
              }}
              label="Field"
              error={props.kvErrorArr[props.index].field}
              helperText={
                props.kvErrorArr[props.index].field ? "Enter Field Name" : ""
              }
            >
              {props.dbTableFields.map((obj, index) => {
                return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText>
              {props.kvErrorArr[props.index].field ? "Enter Field Name" : ""}
            </FormHelperText>
          </FormControl>
          <Checkbox
            checked={Boolean(Number(props.kvArr[props.index].value))}
            onChange={(e) => {
              let temp_kvArr = props.kvArr;
              temp_kvArr[props.index].value = e.target.checked;
              props.setKvArr(temp_kvArr);
              props.setTrig(!props.trig);
            }}
          />
          <IconButton
            onClick={() => {
              removeKeyValue(props.index);
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      );
    default:
      return (
        <div className="key-value-row">
          {/* <TextField
            label="Field"
            value={props.kvArr[props.index].field}
            error={props.kvErrorArr[props.index].field}
            helperText={
              props.kvErrorArr[props.index].field ? "Enter Field Name" : ""
            }
            onChange={(e) => {
              let temp_kvArr = props.kvArr;
              temp_kvArr[props.index].field = e.target.value;
              props.setKvArr(temp_kvArr);
              props.setTrig(!props.trig);
            }}
          /> */}
          <FormControl
            variant="filled"
            sx={{ minWidth: 220 }}
            error={props.kvErrorArr[props.index].field}
          >
            <InputLabel>Field</InputLabel>
            <Select
              value={props.kvArr[props.index].field}
              onChange={(e) => {
                let temp_kvArr = props.kvArr;
                temp_kvArr[props.index].field = e.target.value;
                let field_obj = props.dbTableFields.filter((obj, index) => {
                  return obj.name === e.target.value;
                })[0];
                setFieldType(field_obj.field_type);
                temp_kvArr[props.index].field_type = field_obj.field_type;
                if (field_obj.field_type === "2") {
                  temp_kvArr[props.index].value = false;
                } else {
                  temp_kvArr[props.index].value = "";
                }
                props.setKvArr(temp_kvArr);
                props.setTrig(!props.trig);
              }}
              label="Field"
              error={props.kvErrorArr[props.index].field}
              helperText={
                props.kvErrorArr[props.index].field ? "Enter Field Name" : ""
              }
            >
              {props.dbTableFields.map((obj, index) => {
                return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
              })}
            </Select>
            <FormHelperText>
              {props.kvErrorArr[props.index].field ? "Enter Field Name" : ""}
            </FormHelperText>
          </FormControl>
          <TextField
            label="Value"
            value={props.kvArr[props.index].value}
            error={props.kvErrorArr[props.index].value}
            helperText={
              props.kvErrorArr[props.index].value ? "Enter Value" : ""
            }
            onChange={(e) => {
              let temp_kvArr = props.kvArr;
              temp_kvArr[props.index].value = e.target.value;
              props.setKvArr(temp_kvArr);
              props.setTrig(!props.trig);
            }}
          />
          <IconButton
            onClick={() => {
              removeKeyValue(props.index);
            }}
          >
            <CloseIcon />
          </IconButton>
        </div>
      );
  }
};

const FieldValueRowCreate = (props) => {
  const removeKeyValue = (index) => {
    if (index > -1) {
      let temp = props.kvArr;
      temp.splice(index, 1);
      props.setKvArr(temp);

      let tempErr = props.kvErrorArr;
      tempErr.splice(index, 1);
      props.setKvErrorArr(tempErr);
      props.setTrig(!props.trig);
    }
  };
  return (
    <div className="key-value-row">
      <p className="key-value-field-create">
        {props.kvArr[props.index].field_type === "4"
          ? props.kvArr[props.index].field + " ID"
          : props.kvArr[props.index].field}
      </p>
      {props.kvArr[props.index].field_type === "2" ? (
        <Checkbox
          checked={Boolean(Number(props.kvArr[props.index].value))}
          onChange={(e) => {
            let temp_kvArr = props.kvArr;
            temp_kvArr[props.index].value = e.target.checked;
            props.setKvArr(temp_kvArr);
            props.setTrig(!props.trig);
          }}
        />
      ) : (
        <TextField
          label="Value"
          value={props.kvArr[props.index].value}
          error={props.kvErrorArr[props.index].value}
          helperText={props.kvErrorArr[props.index].value ? "Enter Value" : ""}
          onChange={(e) => {
            let temp_kvArr = props.kvArr;
            temp_kvArr[props.index].value = e.target.value;
            props.setKvArr(temp_kvArr);
            props.setTrig(!props.trig);
          }}
        />
      )}
    </div>
  );
};

const NewBlock = (props) => {
  const [step, setStep] = useState(0);
  const [status, setStatus] = useState(200);

  const [varName, setVarName] = useState("");
  const [varVal, setVarVal] = useState("");
  const [varNameError, setVarNameError] = useState(false);
  const [varValError, setVarValError] = useState(false);

  const [trig, setTrig] = useState(false);

  const [condition, setCondition] = useState("");
  const [conditionError, setConditionError] = useState(false);

  const [kvArr, setKvArr] = useState([]);
  const [kvErrorArr, setKvErrorArr] = useState([]);

  const [fvArr, setFvArr] = useState([]);
  const [fvErrorArr, setFvErrorArr] = useState([]);
  const [dbVarName, setDbVarName] = useState("");
  const [dbTableName, setDbTableName] = useState("");
  const [dbVarNameError, setDbVarNameError] = useState(false);
  const [dbTableNameError, setDbTableNameError] = useState(false);
  const [dbFetchFilter, setDbFetchFilter] = useState(true);
  const [dbTableFields, setDbTableFields] = useState([]);

  const [code, setCode] = useState("");
  const [codeError, setCodeError] = useState(false);

  const [signupEmail, setSignupEmail] = useState(true);
  const [signupUsername, setSignupUsername] = useState(true);
  const [signupName, setSignupName] = useState(true);

  const [dtVarName, setDtVarName] = useState("");
  const [dtType, setDtType] = useState("0");
  const [dtValueType, setDtValueType] = useState("0");
  const [dtCustomValue, setDtCustomValue] = useState("");

  const [dtVarNameError, setDtVarNameError] = useState("");
  const [dtCustomValueError, setDtCustomValueError] = useState("");

  const [placeholder, setPlaceholder] = useState("DD-MM-YYYY HH:MI:SS");

  const [ARTabs, setARTabs] = useState(0);

  const doubleDigit = (number) => {
    if (String(number).length !== 2) {
      return "0" + String(number);
    }
    return number;
  };

  useEffect(() => {
    if (props.activeBlock) {
      if (props.activeBlock.data.type === "response") {
        setStep(1);
        let temp_kvErrArr = [];

        setKvArr(props.activeBlock.data.body.data);
        props.activeBlock.data.body.data.map((obj, index) => {
          return temp_kvErrArr.push({ key: false, value: false });
        });
        setKvErrorArr(temp_kvErrArr);
        setStatus(props.activeBlock.data.body.status);
      } else if (props.activeBlock.data.type === "variable") {
        setStep(2);
        setVarName(props.activeBlock.data.body.name);
        setVarVal(props.activeBlock.data.body.value);
      } else if (props.activeBlock.data.type === "if") {
        setStep(3);
        setCondition(props.activeBlock.data.body.condition);
      } else if (props.activeBlock.data.type === "loop") {
        setStep(4);
        setCondition(props.activeBlock.data.body.condition);
      } else if (props.activeBlock.data.type === "dbfilter") {
        setStep(5);
        setDbTableName(props.activeBlock.data.body.table_name);
        setDbVarName(props.activeBlock.data.body.var_name);
        setFvArr(props.activeBlock.data.body.filter_data);
        let temp_kvErrArr = [];
        props.activeBlock.data.body.filter_data.map((obj, index) => {
          return temp_kvErrArr.push({ field: false, value: false });
        });
        setFvErrorArr(temp_kvErrArr);
        setDbFetchFilter(Boolean(props.activeBlock.data.body.filter_data));
        let table_obj = props.dbMeta.filter((obj, index) => {
          return obj.name === props.activeBlock.data.body.table_name;
        })[0];
        setDbTableFields(table_obj.fields);
      } else if (props.activeBlock.data.type === "dbcreate") {
        setStep(6);
        setDbTableName(props.activeBlock.data.body.table_name);
        setDbVarName(props.activeBlock.data.body.var_name);
        setFvArr(props.activeBlock.data.body.db_data);
        let temp_kvErrArr = [];
        props.activeBlock.data.body.db_data.map((obj, index) => {
          return temp_kvErrArr.push({ field: false, value: false });
        });
        setFvErrorArr(temp_kvErrArr);
      } else if (props.activeBlock.data.type === "dbupdate") {
        setStep(7);
        setDbVarName(props.activeBlock.data.body.var_name);
        setFvArr(props.activeBlock.data.body.db_data);
        let temp_kvErrArr = [];
        props.activeBlock.data.body.db_data.map((obj, index) => {
          return temp_kvErrArr.push({ field: false, value: false });
        });
        setFvErrorArr(temp_kvErrArr);
        let table_obj = props.dbMeta.filter((obj, index) => {
          return obj.name === props.activeBlock.data.body.table_name;
        })[0];
        setDbTableFields(table_obj.fields.slice(1));
      } else if (props.activeBlock.data.type === "dbdelete") {
        setStep(8);
        setDbVarName(props.activeBlock.data.body.var_name);
      } else if (props.activeBlock.data.type === "dbget") {
        setStep(9);
        setDbTableName(props.activeBlock.data.body.table_name);
        setDbVarName(props.activeBlock.data.body.var_name);
        setFvArr(props.activeBlock.data.body.filter_data);
        let temp_kvErrArr = [];
        props.activeBlock.data.body.filter_data.map((obj, index) => {
          return temp_kvErrArr.push({ field: false, value: false });
        });
        setFvErrorArr(temp_kvErrArr);
        let table_obj = props.dbMeta.filter((obj, index) => {
          return obj.name === props.activeBlock.data.body.table_name;
        })[0];
        setDbTableFields(table_obj.fields);
      } else if (props.activeBlock.data.type === "codepy") {
        setStep(10);
        setCode(props.activeBlock.data.body.code);
      } else if (props.activeBlock.data.type === "datetimevar") {
        setStep(13);
        setDtVarName(props.activeBlock.data.body.var_name);
        setDtValueType(props.activeBlock.data.body.dtvaluetype);
        setDtType(props.activeBlock.data.body.dttype);

        if (props.activeBlock.data.body.dtvaluetype === "1") {
          let date = new Date(props.activeBlock.data.body.value);
          setDtCustomValue(
            doubleDigit(date.getUTCDate()) +
              "-" +
              doubleDigit(date.getUTCMonth() + 1) +
              "-" +
              date.getUTCFullYear() +
              " " +
              doubleDigit(date.getUTCHours()) +
              ":" +
              doubleDigit(date.getUTCMinutes()) +
              ":" +
              doubleDigit(date.getUTCSeconds())
          );
        }
      } else if (props.activeBlock.data.type === "jsontodatetime") {
        setStep(14);
        setDtVarName(props.activeBlock.data.body.name);
        setDtCustomValue(props.activeBlock.data.body.value);
      }
    }
  }, []);

  const varRegex = /^{{2}(.*)}{2}$/;

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleAddBlock = (step) => {
    let data;
    if (step === 1) {
      for (let i = 0; i < kvErrorArr.length; i++) {
        if (!Boolean(kvArr[i].key)) {
          let temp_arr = kvErrorArr;
          temp_arr[i].key = true;
          setKvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(kvArr[i].value)) {
          let temp_arr = kvErrorArr;
          temp_arr[i].value = true;
          setKvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "response",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: kvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(kvArr));
      data.append("status", status);
      data.append("type", "response");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 2) {
      setVarNameError(false);
      setVarValError(false);
      if (!Boolean(varName)) {
        setVarNameError(true);
        return;
      }
      if (!Boolean(varVal)) {
        setVarValError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "variable",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: { name: varName, value: varVal },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "variable");
      data.append("name", varName);
      data.append("value", varVal);
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 3) {
      setConditionError(false);
      if (!Boolean(condition)) {
        setConditionError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "if",
          next: { true: "", false: "" },
          prev: lastBlock ? lastBlock.id : "",
          body: { condition: condition },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "if");
      data.append("condition", condition);
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 4) {
      setConditionError(false);
      if (!Boolean(condition)) {
        setConditionError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "loop",
          next: { true: "", false: "" },
          prev: lastBlock ? lastBlock.id : "",
          body: { condition: condition },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "loop");
      data.append("condition", condition);
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 5) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      if (dbFetchFilter)
        for (let i = 0; i < fvErrorArr.length; i++) {
          if (fvArr[i].field_type === "2") {
            fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
            continue;
          }
          if (!Boolean(fvArr[i].field)) {
            let temp_arr = fvErrorArr;
            temp_arr[i].field = true;
            setFvErrorArr(temp_arr);
            setTrig(!trig);
            return;
          }
          if (!Boolean(fvArr[i].value)) {
            let temp_arr = fvErrorArr;
            temp_arr[i].value = true;
            setFvErrorArr(temp_arr);
            setTrig(!trig);
            return;
          }
        }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "dbfilter",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: fvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(dbFetchFilter ? fvArr : []));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbfilter");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 6) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "dbcreate",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: fvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbcreate");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 7) {
      setDbVarNameError(false);
      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "dbupdate",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: fvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("type", "dbupdate");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 8) {
      setDbVarNameError(false);
      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "dbdelete",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: fvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("var_name", dbVarName);
      data.append("type", "dbdelete");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 9) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "dbfilter",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: {
            status: status,
            data: fvArr,
          },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbget");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 10) {
      setCodeError(false);

      if (!Boolean(code)) {
        setCodeError(true);
        return;
      }

      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "codepy",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: { name: varName, value: varVal },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("code", code);
      data.append("endpoint", props.activeEnd);
      data.append("type", "codepy");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 11) {
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "authsignup");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 12) {
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "authsignin");
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 13) {
      setDtCustomValueError(false);
      setDtVarNameError(false);
      let date;
      const timeRegex =
        /^([0-1]{1}[0-9]{1}|2{1}[0-3]{1})(:[0-5]{1}[0-9]{1}){2}$/gm;

      function dateIsValid(date) {
        if (
          typeof date === "object" &&
          date !== null &&
          typeof date.getTime === "function" &&
          !isNaN(date)
        ) {
          return true;
        }

        return false;
      }
      if (!Boolean(dtVarName)) {
        setDtVarNameError(true);
        return;
      }
      if (dtValueType === "1") {
        if (dtCustomValue.length !== 19) {
          setDtCustomValueError(true);
          return;
        }
      }
      if (dtValueType === "0") {
        date = null;
      } else {
        let day = Number(dtCustomValue.slice(0, 2));
        let month = Number(dtCustomValue.slice(3, 5));
        let year = Number(dtCustomValue.slice(6, 10));
        let hour = Number(dtCustomValue.slice(11, 13));
        let minute = Number(dtCustomValue.slice(14, 16));
        let second = Number(dtCustomValue.slice(17, 19));
        date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      }
      if (dtValueType === "1" && !dateIsValid(date)) {
        setDtCustomValueError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }

      tempArr.push({
        data: {
          type: "variable",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: { name: varName, value: varVal },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "datetimevar");
      data.append("name", dtVarName);
      data.append("value", dtValueType === "1" ? date.toJSON() : "");
      data.append("dttype", dtType);
      data.append("dtvaluetype", dtValueType);
      data.append("add", JSON.stringify(props.addBlock));
    } else if (step === 14) {
      setDtVarNameError(false);
      setDtCustomValueError(false);
      if (!Boolean(dtVarName)) {
        setDtVarNameError(true);
        return;
      }
      if (!Boolean(dtCustomValue)) {
        setDtCustomValueError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }
      tempArr.push({
        data: {
          type: "variable",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: { name: varName, value: varVal },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "jsontodatetime");
      data.append("name", dtVarName);
      data.append("value", dtCustomValue);
      data.append("add", JSON.stringify(props.addBlock));
    }

    axios
      .post("https://api.fabloq.com/user/block/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        props.setBlockJsonArr(res.data.blocks);
        props.arrangeBlocks(res.data.blocks, props.errors);
      });
  };

  const handleChangeBlock = () => {
    let data;
    if (step === 1) {
      for (let i = 0; i < kvErrorArr.length; i++) {
        if (!Boolean(kvArr[i].key)) {
          let temp_arr = kvErrorArr;
          temp_arr[i].key = true;
          setKvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(kvArr[i].value)) {
          let temp_arr = kvErrorArr;
          temp_arr[i].value = true;
          setKvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(kvArr));
      data.append("status", status);
      data.append("id", props.activeBlock.id);
      data.append("type", "response");
    } else if (step === 2) {
      setVarNameError(false);
      setVarValError(false);
      if (!Boolean(varName)) {
        setVarNameError(true);
        return;
      }
      if (!Boolean(varVal)) {
        setVarValError(true);
        return;
      }
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "variable");
      data.append("name", varName);
      data.append("id", props.activeBlock.id);
      data.append("value", varVal);
    } else if (step === 3) {
      setConditionError(false);
      if (!Boolean(condition)) {
        setConditionError(true);
        return;
      }
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "if");
      data.append("condition", condition);
      data.append("id", props.activeBlock.id);
    } else if (step === 4) {
      setConditionError(false);
      if (!Boolean(condition)) {
        setConditionError(true);
        return;
      }
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "loop");
      data.append("condition", condition);
      data.append("id", props.activeBlock.id);
    } else if (step === 5) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      if (dbFetchFilter)
        for (let i = 0; i < fvErrorArr.length; i++) {
          if (fvArr[i].field_type === "2") {
            fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
            continue;
          }
          if (!Boolean(fvArr[i].field)) {
            let temp_arr = fvErrorArr;
            temp_arr[i].field = true;
            setFvErrorArr(temp_arr);
            setTrig(!trig);
            return;
          }
          if (!Boolean(fvArr[i].value)) {
            let temp_arr = fvErrorArr;
            temp_arr[i].value = true;
            setFvErrorArr(temp_arr);
            setTrig(!trig);
            return;
          }
        }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(dbFetchFilter ? fvArr : []));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbfilter");
      data.append("id", props.activeBlock.id);
    } else if (step === 6) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbcreate");
      data.append("id", props.activeBlock.id);
    } else if (step === 7) {
      setDbVarNameError(false);
      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("type", "dbupdate");
      data.append("id", props.activeBlock.id);
    } else if (step === 8) {
      setDbVarNameError(false);
      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("var_name", dbVarName);
      data.append("type", "dbdelete");
      data.append("id", props.activeBlock.id);
    } else if (step === 9) {
      setDbVarNameError(false);
      setDbTableNameError(false);

      if (!Boolean(dbVarName)) {
        setDbVarNameError(true);
        return;
      }
      if (!Boolean(dbTableName)) {
        setDbTableNameError(true);
        return;
      }
      for (let i = 0; i < fvErrorArr.length; i++) {
        if (fvArr[i].field_type === "2") {
          fvArr[i].value = Boolean(fvArr[i].value) ? "1" : "0";
          continue;
        }
        if (!Boolean(fvArr[i].field)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].field = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
        if (!Boolean(fvArr[i].value)) {
          let temp_arr = fvErrorArr;
          temp_arr[i].value = true;
          setFvErrorArr(temp_arr);
          setTrig(!trig);
          return;
        }
      }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("data", JSON.stringify(fvArr));
      data.append("var_name", dbVarName);
      data.append("table_name", dbTableName);
      data.append("type", "dbget");
      data.append("id", props.activeBlock.id);
    } else if (step === 10) {
      setCodeError(false);

      if (!Boolean(code)) {
        setCodeError(true);
        return;
      }

      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("code", code);
      data.append("type", "codepy");
      data.append("id", props.activeBlock.id);
    } else if (step === 13) {
      setDtCustomValueError(false);
      setDtVarNameError(false);
      let date;
      const timeRegex =
        /^([0-1]{1}[0-9]{1}|2{1}[0-3]{1})(:[0-5]{1}[0-9]{1}){2}$/gm;

      function dateIsValid(date) {
        if (
          typeof date === "object" &&
          date !== null &&
          typeof date.getTime === "function" &&
          !isNaN(date)
        ) {
          return true;
        }

        return false;
      }
      if (!Boolean(dtVarName)) {
        setDtVarNameError(true);
        return;
      }
      if (dtValueType === "1") {
        if (dtCustomValue.length !== 19) {
          setDtCustomValueError(true);
          return;
        }
      }
      if (dtValueType === "0") {
        date = null;
      } else {
        let day = Number(dtCustomValue.slice(0, 2));
        let month = Number(dtCustomValue.slice(3, 5));
        let year = Number(dtCustomValue.slice(6, 10));
        let hour = Number(dtCustomValue.slice(11, 13));
        let minute = Number(dtCustomValue.slice(14, 16));
        let second = Number(dtCustomValue.slice(17, 19));
        date = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      }
      if (dtValueType === "1" && !dateIsValid(date)) {
        setDtCustomValueError(true);
        return;
      }
      let tempArr = props.blockJsonArr;
      let lastBlock;
      for (let i = 0; i < props.blockJsonArr.length; i++) {
        if (!props.blockJsonArr[i].data.next) {
          lastBlock = props.blockJsonArr[i];
        }
      }

      tempArr.push({
        data: {
          type: "variable",
          next: "",
          prev: lastBlock ? lastBlock.id : "",
          body: { name: varName, value: varVal },
        },
      });
      props.setBlockJsonArr(tempArr);
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "datetimevar");
      data.append("name", dtVarName);
      data.append("value", dtValueType === "1" ? date.toJSON() : "");
      data.append("dttype", dtType);
      data.append("dtvaluetype", dtValueType);
      data.append("id", props.activeBlock.id);
    } else if (step === 14) {
      setDtVarNameError(false);
      setDtCustomValueError(false);
      if (!Boolean(dtVarName)) {
        setDtVarNameError(true);
        return;
      }
      if (!Boolean(dtCustomValue)) {
        setDtCustomValueError(true);
        return;
      }
      props.setBlockDialog(false);

      data = new FormData();
      data.append("endpoint", props.activeEnd);
      data.append("type", "jsontodatetime");
      data.append("name", dtVarName);
      data.append("id", props.activeBlock.id);
      data.append("value", dtCustomValue);
    }

    axios
      .put("https://api.fabloq.com/user/block/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        props.setBlockJsonArr([]);
        props.setBlockJsonArr(res.data.blocks);
        props.arrangeBlocks(res.data.blocks, props.errors);
      });
  };

  switch (step) {
    case 0:
      return (
        <>
          <DialogTitle>Add a block</DialogTitle>
          <DialogTitle className="block-dialog-subtitle">
            Control Blocks
          </DialogTitle>
          <DialogContent className="block-dialog-content">
            <Button
              variant="contained"
              onClick={() => {
                setStep(1);
              }}
            >
              Response
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(2);
              }}
            >
              Variable
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(3);
              }}
            >
              IF
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(4);
              }}
            >
              Loop
            </Button>
          </DialogContent>
          <DialogTitle className="block-dialog-subtitle">
            Database Blocks
          </DialogTitle>
          <DialogContent className="block-dialog-content">
            <Button
              variant="contained"
              onClick={() => {
                setStep(9);
              }}
            >
              Fetch One
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(5);
              }}
            >
              Fetch Many
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(6);
              }}
            >
              Create
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(7);
              }}
            >
              Update
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(8);
              }}
            >
              Delete
            </Button>
          </DialogContent>
          <DialogTitle className="block-dialog-subtitle">
            Authentication
          </DialogTitle>
          <DialogContent className="block-dialog-content">
            <Button
              variant="contained"
              onClick={() => {
                handleAddBlock(11);
              }}
            >
              User Signup
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleAddBlock(12);
              }}
            >
              User Sign In
            </Button>
          </DialogContent>
          <DialogTitle className="block-dialog-subtitle">Misc</DialogTitle>
          <DialogContent className="block-dialog-content">
            <Button
              variant="contained"
              onClick={() => {
                setStep(13);
              }}
            >
              Date Time
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(14);
              }}
            >
              JSON to Date Time
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setStep(10);
              }}
            >
              Python Script
            </Button>
            {/*<Button
              variant="contained"
              onClick={() => {
                setStep(15);
              }}
            >
              API Request
            </Button>*/}
          </DialogContent>
          <DialogContent>
            <p className="feature-message">
              Want more features? Talk to us by opening chat in bottom right
              corner.
            </p>
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
          </DialogActions>
        </>
      );
    case 1:
      return (
        <>
          <DialogTitle>Response Block</DialogTitle>
          <DialogContent>
            <FormControl fullWidth className="text-input-margin-top">
              <InputLabel>Status Code</InputLabel>
              <Select
                value={status}
                label="Status Code"
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value={200}>200</MenuItem>
                <MenuItem value={201}>201</MenuItem>
                <MenuItem value={400}>400</MenuItem>
                <MenuItem value={401}>401</MenuItem>
              </Select>
            </FormControl>
            <InputLabel>Data</InputLabel>
            {kvArr.map((obj, index) => {
              return (
                <KeyValueRow
                  key={index}
                  index={index}
                  obj={obj}
                  kvArr={kvArr}
                  setKvArr={setKvArr}
                  kvErrorArr={kvErrorArr}
                  setKvErrorArr={setKvErrorArr}
                  setTrig={setTrig}
                  trig={trig}
                />
              );
            })}
            <Fab
              color="primary"
              onClick={() => {
                let temp_kvArr = kvArr;
                temp_kvArr.push({ key: "", value: "" });

                let temp_kvErrArr = kvErrorArr;
                temp_kvErrArr.push({ key: false, value: false });

                setKvArr(temp_kvArr);
                setKvErrorArr(temp_kvErrArr);
                setTrig(!trig);
              }}
            >
              <AddIcon />
            </Fab>
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(1);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 2:
      return (
        <>
          <DialogTitle>Variable Block</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable Name"
              value={varName}
              onChange={(e) => setVarName(e.target.value)}
              error={varNameError}
              helperText={varNameError ? "Please enter variable name." : ""}
            />
            <TextField
              label="Variable Value"
              value={varVal}
              onChange={(e) => setVarVal(e.target.value)}
              error={varValError}
              helperText={varValError ? "Please enter variable value." : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(2);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 3:
      return (
        <>
          <DialogTitle>If Block</DialogTitle>
          <DialogContent>
            <TextField
              label="Enter condition"
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
              error={conditionError}
              helperText={conditionError ? "Please enter a conditon" : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(3);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 4:
      return (
        <>
          <DialogTitle>Loop Block</DialogTitle>
          <DialogContent>
            <TextField
              label="Enter condition"
              value={condition}
              onChange={(e) => setCondition(e.target.value)}
              error={conditionError}
              helperText={conditionError ? "Please enter a conditon" : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(4);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 5:
      return (
        <>
          <DialogTitle>Database Fetch Many</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable to store result"
              value={dbVarName}
              onChange={(e) => {
                setDbVarName(e.target.value);
              }}
              error={dbVarNameError}
              helperText={dbVarNameError ? "Please enter variable name." : ""}
            />
            {/* <TextField
              label="Table Name"
              value={dbTableName}
              onChange={(e) => {
                setDbTableName(e.target.value);
              }}
              error={dbTableNameError}
              helperText={dbTableNameError ? "Please enter table name." : ""}
            /> */}
            <FormControl
              variant="filled"
              sx={{ minWidth: 220 }}
              error={dbTableNameError}
            >
              <InputLabel>Table Name</InputLabel>
              <Select
                value={dbTableName}
                onChange={(e) => {
                  setDbTableName(e.target.value);
                  setFvArr([]);
                  setFvErrorArr([]);
                  let table_obj = props.dbMeta.filter((obj, index) => {
                    return obj.name === e.target.value;
                  })[0];

                  setDbTableFields(table_obj.fields);
                  // setTrig(!trig);
                }}
                label="Table Name"
                error={dbTableNameError}
                helperText={dbTableNameError ? "Please enter table name." : ""}
              >
                {props.dbMeta.map((obj, index) => {
                  return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText>
                {dbTableNameError ? "Please enter table name." : ""}
              </FormHelperText>
            </FormControl>
            <FormControl variant="standard" className="fetch-many-select">
              <InputLabel>Select Data</InputLabel>
              <Select
                value={dbFetchFilter}
                onChange={(e) => {
                  setDbFetchFilter(e.target.value);
                }}
              >
                <MenuItem value={false}>All</MenuItem>
                <MenuItem value={true}>Filter</MenuItem>
              </Select>
            </FormControl>
            {dbFetchFilter ? (
              <>
                <InputLabel>Filter</InputLabel>
                {fvArr.map((obj, index) => {
                  return (
                    <FieldValueRow
                      key={index}
                      index={index}
                      obj={obj}
                      kvArr={fvArr}
                      setKvArr={setFvArr}
                      kvErrorArr={fvErrorArr}
                      setKvErrorArr={setFvErrorArr}
                      setTrig={setTrig}
                      trig={trig}
                      dbTableFields={dbTableFields}
                      dbMeta={props.dbMeta}
                    />
                  );
                })}
                {dbTableName ? (
                  <Fab
                    color="primary"
                    onClick={() => {
                      let temp_fvArr = fvArr;
                      temp_fvArr.push({ field: "", value: "" });
                      let temp_fvErrArr = fvErrorArr;
                      temp_fvErrArr.push({ field: false, value: false });
                      setFvArr(temp_fvArr);
                      setFvErrorArr(temp_fvErrArr);
                      setTrig(!trig);
                    }}
                  >
                    <AddIcon />
                  </Fab>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(5);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 6:
      return (
        <>
          <DialogTitle>Database Create</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable to store result"
              value={dbVarName}
              onChange={(e) => {
                setDbVarName(e.target.value);
              }}
              error={dbVarNameError}
              helperText={dbVarNameError ? "Please enter variable name." : ""}
            />
            {/* <TextField
              label="Table Name"
              value={dbTableName}
              onChange={(e) => {
                setDbTableName(e.target.value);
              }}
              error={dbTableNameError}
              helperText={dbTableNameError ? "Please enter table name." : ""}
            /> */}
            <FormControl
              variant="filled"
              sx={{ minWidth: 220 }}
              error={dbTableNameError}
              helperText={dbTableNameError ? "Please enter table name." : ""}
            >
              <InputLabel>Table Name</InputLabel>
              <Select
                value={dbTableName}
                onChange={(e) => {
                  setDbTableName(e.target.value);
                  let table_obj = props.dbMeta.filter((obj, index) => {
                    return obj.name === e.target.value;
                  })[0];
                  let temp_fvArr = [];
                  let temp_fvErrArr = [];

                  for (
                    let i = table_obj.populated ? 0 : 1;
                    i < table_obj.fields.length;
                    i++
                  ) {
                    temp_fvArr.push({
                      field: table_obj.fields[i].name,
                      value: "",
                      field_type: table_obj.fields[i].field_type,
                    });

                    temp_fvErrArr.push({ field: false, value: false });

                    setFvArr(temp_fvArr);
                    setFvErrorArr(temp_fvErrArr);
                  }
                  setTrig(!trig);
                }}
                label="Table Name"
                error={dbTableNameError}
                helperText={dbTableNameError ? "Please enter table name." : ""}
              >
                <MenuItem value="">
                  <em>Select a table</em>
                </MenuItem>
                {props.dbMeta.map((obj, index) => {
                  return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText>
                {dbTableNameError ? "Please enter table name." : ""}
              </FormHelperText>
            </FormControl>
            <InputLabel>Data</InputLabel>
            {fvArr.map((obj, index) => {
              return (
                <FieldValueRowCreate
                  key={index}
                  index={index}
                  obj={obj}
                  kvArr={fvArr}
                  setKvArr={setFvArr}
                  kvErrorArr={fvErrorArr}
                  setKvErrorArr={setFvErrorArr}
                  setTrig={setTrig}
                  trig={trig}
                />
              );
            })}
            {/* <Fab
              color="primary"
              onClick={() => {
                let temp_fvArr = fvArr;
                temp_fvArr.push({ field: "", value: "" });

                let temp_fvErrArr = fvErrorArr;
                temp_fvErrArr.push({ field: false, value: false });

                setFvArr(temp_fvArr);
                setFvErrorArr(temp_fvErrArr);
                setTrig(!trig);
              }}
            >
              <AddIcon />
            </Fab> */}
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(6);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 7:
      return (
        <>
          <DialogTitle>Database Update</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable to update"
              value={dbVarName}
              onChange={(e) => {
                setDbVarName(e.target.value);
                let db_blocks = props.blockJsonArr
                  .filter((obj, index) => {
                    return (
                      obj.data.type === "dbfilter" ||
                      obj.data.type === "dbget" ||
                      obj.data.type === "dbcreate"
                    );
                  })
                  .filter((obj, index) => {
                    return obj.data.body.var_name === e.target.value;
                  });
                if (Boolean(db_blocks.length)) {
                  let var_block = db_blocks.pop();
                  let table_obj = props.dbMeta.filter((obj, index) => {
                    return obj.name === var_block.data.body.table_name;
                  })[0];
                  setDbTableFields(
                    table_obj.fields.slice(table_obj.populated ? 0 : 1)
                  );
                }
              }}
              error={dbVarNameError}
              helperText={dbVarNameError ? "Please enter variable name." : ""}
            />
            <InputLabel>Data</InputLabel>
            {fvArr.map((obj, index) => {
              return (
                <FieldValueRow
                  key={index}
                  index={index}
                  obj={obj}
                  kvArr={fvArr}
                  setKvArr={setFvArr}
                  kvErrorArr={fvErrorArr}
                  setKvErrorArr={setFvErrorArr}
                  setTrig={setTrig}
                  trig={trig}
                  dbTableFields={dbTableFields}
                  dbMeta={props.dbMeta}
                />
              );
            })}
            <Fab
              color="primary"
              onClick={() => {
                let temp_fvArr = fvArr;
                temp_fvArr.push({ field: "", value: "" });

                let temp_fvErrArr = fvErrorArr;
                temp_fvErrArr.push({ field: false, value: false });

                setFvArr(temp_fvArr);
                setFvErrorArr(temp_fvErrArr);
                setTrig(!trig);
              }}
            >
              <AddIcon />
            </Fab>
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(7);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 8:
      return (
        <>
          <DialogTitle>Database Delete</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable to delete"
              value={dbVarName}
              onChange={(e) => {
                setDbVarName(e.target.value);
              }}
              error={dbVarNameError}
              helperText={dbVarNameError ? "Please enter variable name." : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(8);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 9:
      return (
        <>
          <DialogTitle>Database Fetch One</DialogTitle>
          <DialogContent>
            <TextField
              label="Variable to store result"
              value={dbVarName}
              onChange={(e) => {
                setDbVarName(e.target.value);
              }}
              error={dbVarNameError}
              helperText={dbVarNameError ? "Please enter variable name." : ""}
            />
            {/* <TextField
              label="Table Name"
              value={dbTableName}
              onChange={(e) => {
                setDbTableName(e.target.value);
              }}
              error={dbTableNameError}
              helperText={dbTableNameError ? "Please enter table name." : ""}
            /> */}
            <FormControl
              variant="filled"
              sx={{ minWidth: 220 }}
              error={dbTableNameError}
            >
              <InputLabel>Table Name</InputLabel>
              <Select
                value={dbTableName}
                onChange={(e) => {
                  setDbTableName(e.target.value);
                  setFvArr([]);
                  setFvErrorArr([]);
                  let table_obj = props.dbMeta.filter((obj, index) => {
                    return obj.name === e.target.value;
                  })[0];

                  setDbTableFields(table_obj.fields);
                }}
                label="Table Name"
                error={dbTableNameError}
                helperText={dbTableNameError ? "Please enter table name." : ""}
              >
                <MenuItem value="">
                  <em>Select a table</em>
                </MenuItem>
                {props.dbMeta.map((obj, index) => {
                  return <MenuItem value={obj.name}>{obj.name}</MenuItem>;
                })}
              </Select>
              <FormHelperText>
                {dbTableNameError ? "Please enter table name." : ""}
              </FormHelperText>
            </FormControl>
            <InputLabel>Filter</InputLabel>
            {fvArr.map((obj, index) => {
              return (
                <FieldValueRow
                  key={index}
                  index={index}
                  obj={obj}
                  kvArr={fvArr}
                  setKvArr={setFvArr}
                  kvErrorArr={fvErrorArr}
                  setKvErrorArr={setFvErrorArr}
                  setTrig={setTrig}
                  trig={trig}
                  dbTableFields={dbTableFields}
                  dbMeta={props.dbMeta}
                />
              );
            })}
            {dbTableName ? (
              <Fab
                color="primary"
                onClick={() => {
                  let temp_fvArr = fvArr;
                  temp_fvArr.push({ field: "", value: "" });

                  let temp_fvErrArr = fvErrorArr;
                  temp_fvErrArr.push({ field: false, value: false });

                  setFvArr(temp_fvArr);
                  setFvErrorArr(temp_fvErrArr);
                  setTrig(!trig);
                }}
              >
                <AddIcon />
              </Fab>
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(9);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </>
      );
    case 10:
      return (
        <div className="block-dialog-script">
          <DialogTitle>Script</DialogTitle>
          <DialogContent>
            <TextField
              multiline
              rows={12}
              fullWidth
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(10);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </div>
      );
    case 13:
      return (
        <div className="block-dialog-script">
          <DialogTitle>Date Time</DialogTitle>
          <DialogContent
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <TextField
              label="Variable Name"
              fullWidth
              value={dtVarName}
              onChange={(e) => {
                setDtVarName(e.target.value);
              }}
              error={dtVarNameError}
              helperText={dtVarNameError ? "Enter a variable value." : ""}
            />
            <div className="key-value-row">
              {/* <FormControl variant="filled" sx={{ minWidth: "45%" }}>
                <InputLabel>Type</InputLabel>
                <Select
                  label="Type"
                  value={dtType}
                  onChange={(e) => {
                    setDtType(e.target.value);
                    if (e.target.value === "0") {
                      setPlaceholder("DD-MM-YYYY HH:MI:SS");
                    } else if (e.target.value === "1") {
                      setPlaceholder("DD-MM-YYYY");
                    } else if (e.target.value === "2") {
                      setPlaceholder("HH:MI:SS");
                    }
                  }}
                >
                  <MenuItem value="0">Date Time</MenuItem>
                  <MenuItem value="1">Date</MenuItem>
                  <MenuItem value="2">Time</MenuItem>
                </Select>
                <FormHelperText></FormHelperText>
              </FormControl> */}
              <FormControl variant="filled" sx={{ minWidth: "45%" }}>
                <InputLabel>Value</InputLabel>
                <Select
                  label="Value"
                  value={dtValueType}
                  onChange={(e) => {
                    setDtValueType(e.target.value);
                  }}
                >
                  <MenuItem value="0">Now</MenuItem>
                  <MenuItem value="1">Custom</MenuItem>
                </Select>
                <FormHelperText></FormHelperText>
              </FormControl>
            </div>
            {dtValueType === "1" ? (
              <TextField
                label="Custom Value"
                fullWidth
                placeholder={placeholder}
                value={dtCustomValue}
                onChange={(e) => {
                  setDtCustomValue(e.target.value);
                }}
                error={dtCustomValueError}
                helperText={
                  dtCustomValueError
                    ? "Enter valid value in " + placeholder + " format."
                    : ""
                }
              />
            ) : (
              ""
            )}
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(13);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </div>
      );
    case 14:
      return (
        <div className="block-dialog-script">
          <DialogTitle>JSON to Date Time</DialogTitle>
          <DialogContent
            style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            <TextField
              label="Variable Name"
              fullWidth
              value={dtVarName}
              onChange={(e) => {
                setDtVarName(e.target.value);
              }}
              error={dtVarNameError}
              helperText={dtVarNameError ? "Enter a variable value." : ""}
            />
            <TextField
              label="Value"
              fullWidth
              value={dtCustomValue}
              onChange={(e) => {
                setDtCustomValue(e.target.value);
              }}
              error={dtCustomValueError}
              helperText={dtCustomValueError ? "Enter valid value." : ""}
            />
          </DialogContent>
          <DialogActions>
            <Button>Cancel</Button>
            <Button
              onClick={() => {
                if (props.activeBlock) {
                  handleChangeBlock();
                } else {
                  handleAddBlock(14);
                }
              }}
            >
              Add
            </Button>
          </DialogActions>
        </div>
      );
    // case 15:
    //   return (
    //     <>
    //       <DialogTitle>API Request</DialogTitle>
    //       <DialogContent>
    //         <TextField label="Variable to store result" />
    //         {/* <TextField
    //             label="Table Name"
    //             value={dbTableName}
    //             onChange={(e) => {
    //               setDbTableName(e.target.value);
    //             }}
    //             error={dbTableNameError}
    //             helperText={dbTableNameError ? "Please enter table name." : ""}
    //           /> */}
    //         <FormControl
    //           variant="filled"
    //           sx={{ minWidth: 220 }}
    //           // error={dbTableNameError}
    //         >
    //           <InputLabel>Method</InputLabel>
    //           <Select
    //             value={dbTableName}
    //             // onChange={(e) => {
    //             //   setDbTableName(e.target.value);
    //             //   setFvArr([]);
    //             //   setFvErrorArr([]);
    //             //   let table_obj = props.dbMeta.filter((obj, index) => {
    //             //     return obj.name === e.target.value;
    //             //   })[0];

    //             //   setDbTableFields(table_obj.fields);
    //             //   // setTrig(!trig);
    //             // }}
    //             label="Table Name"
    //             // error={dbTableNameError}
    //             // helperText={dbTableNameError ? "Please enter table name." : ""}
    //           >
    //             <MenuItem value="GET">GET</MenuItem>
    //             <MenuItem value="POST">POST</MenuItem>
    //             <MenuItem value="PUT">PUT</MenuItem>
    //             <MenuItem value="DELETE">DELETE</MenuItem>
    //           </Select>
    //           {/* <FormHelperText>
    //             {dbTableNameError ? "Please enter table name." : ""}
    //           </FormHelperText> */}
    //         </FormControl>
    //         <Tabs
    //           value={ARTabs}
    //           onChange={(e, v) => {
    //             setARTabs(v);
    //           }}
    //         >
    //           <Tab label="Headers" {...a11yProps(0)} />
    //           <Tab label="Body" {...a11yProps(1)} />
    //         </Tabs>
    //       </DialogContent>
    //       <DialogActions>
    //         <Button>Cancel</Button>
    //         <Button
    //           onClick={() => {
    //             if (props.activeBlock) {
    //               handleChangeBlock();
    //             } else {
    //               handleAddBlock(5);
    //             }
    //           }}
    //         >
    //           Add
    //         </Button>
    //       </DialogActions>
    //     </>
    //   );
  }
};

const GetKeyValue = (props) => {
  const [key, setKey] = useState("");
  const [value, setValue] = useState("");
  const [keyErr, setKeyErr] = useState(false);
  const [valueErr, setValueErr] = useState(false);

  return (
    <div className="get-key-value">
      <FormGroup>
        <OutlinedInput
          className="get-key-value-key"
          placeholder="Parameter"
          value={props.testGetData[props.index].key}
          onChange={(e) => {
            let temp = props.testGetData;
            if (props.index === props.testGetData.length - 1) {
              temp.push({ key: "", value: "" });
            }
            temp[props.index].key = e.target.value;
            props.setTestGetData(temp);
            props.setTrig(!props.trig);
          }}
          error={keyErr}
        />
      </FormGroup>
      <FormGroup>
        <OutlinedInput
          className="get-key-value-value"
          placeholder="Value"
          value={props.testGetData[props.index].value}
          onChange={(e) => {
            let temp = props.testGetData;
            if (props.index === props.testGetData.length - 1) {
              temp.push({ key: "", value: "" });
            }
            temp[props.index].value = e.target.value;
            props.setTestGetData(temp);
            props.setTrig(!props.trig);
          }}
          error={valueErr}
        />
      </FormGroup>
      <IconButton
        disabled={
          !Boolean(props.testGetData[props.index].value) &&
          !Boolean(props.testGetData[props.index].key)
        }
        onClick={() => {
          let temp = props.testGetData;
          temp.splice(props.index, 1);
          props.setTestGetData(temp);
          props.setTrig(!props.trig);
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
};

const Console = (props) => {
  const [loader, setLoader] = useState(false);

  const handleTestSend = () => {
    setLoader(true);
    if (Number(props.endMethod) === 0) {
      let paramString = "";
      for (let i = 0; i < props.testGetData.length; i++) {
        if (
          Boolean(props.testGetData[i].key) &&
          Boolean(props.testGetData[i].value)
        ) {
          if (i !== 0) {
            paramString += "&";
          } else {
            paramString += "?";
          }
          paramString +=
            props.testGetData[i].key + "=" + props.testGetData[i].value;
        }
      }
      axios
        .get(
          "https://api.fabloq.com/user/testing/auth/" + props.projectId + "/",
          {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          axios
            .get(
              "https://api.fabloq.com/" +
                props.proName +
                "/" +
                props.endPath +
                paramString,
              {
                headers: {
                  Authorization: "Bearer " + res.data.token,
                },
              }
            )
            .then((res) => {
              props.setTestResult(JSON.stringify(res.data, null, 2));
              props.setTestResultStatus(res.status);
              props.setErrors({ block_id: "" });
              setLoader(false);
              props.arrangeBlocks(props.blockJsonArr, { block_id: "" });
            })
            .catch((err) => {
              props.setTestResult(err.response.data.message);
              props.setErrors(err.response.data);
              props.setTestResultStatus(
                err.response.status + " " + err.response.statusText
              );
              setLoader(false);
              props.setShowError(true);
              props.arrangeBlocks(props.blockJsonArr, err.response.data);
            });
        });
    } else {
      try {
        JSON.parse(props.testBody ? props.testBody : "{}");
        props.setTestBodyMessage("");
        props.setTestBody(
          JSON.stringify(
            JSON.parse(props.testBody ? props.testBody : "{}"),
            null,
            2
          )
        );
        if (Number(props.endMethod) === 1) {
          axios
            .get(
              "https://api.fabloq.com/user/testing/auth/" +
                props.projectId +
                "/",
              {
                headers: {
                  Authorization: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              axios
                .post(
                  "https://api.fabloq.com/" +
                    props.proName +
                    "/" +
                    props.endPath,
                  JSON.parse(props.testBody ? props.testBody : "{}"),
                  {
                    headers: {
                      Authorization: "Bearer " + res.data.token,
                    },
                  }
                )
                .then((res) => {
                  props.setTestResult(JSON.stringify(res.data, null, 2));
                  props.setTestResultStatus(res.status);
                  props.setErrors({ block_id: "" });
                  setLoader(false);
                  props.arrangeBlocks(props.blockJsonArr, { block_id: "" });
                })
                .catch((err) => {
                  props.setTestResult(err.response.data.message);
                  props.setErrors(err.response.data);
                  props.setTestResultStatus(
                    err.response.status + " " + err.response.statusText
                  );
                  setLoader(false);
                  props.setShowError(true);
                  props.arrangeBlocks(props.blockJsonArr, err.response.data);
                });
            });
        } else if (Number(props.endMethod) === 2) {
          axios
            .get(
              "https://api.fabloq.com/user/testing/auth/" +
                props.projectId +
                "/",
              {
                headers: {
                  Authorization: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              axios
                .put(
                  "https://api.fabloq.com/" +
                    props.proName +
                    "/" +
                    props.endPath,
                  JSON.parse(props.testBody ? props.testBody : "{}"),
                  {
                    headers: {
                      Authorization: "Bearer " + res.data.token,
                    },
                  }
                )
                .then((res) => {
                  props.setTestResult(JSON.stringify(res.data, null, 2));
                  props.setTestResultStatus(res.status);
                  props.setErrors({ block_id: "" });
                  setLoader(false);
                  props.arrangeBlocks(props.blockJsonArr, { block_id: "" });
                })
                .catch((err) => {
                  props.setTestResult(err.response.data.message);
                  props.setErrors(err.response.data);
                  props.setTestResultStatus(
                    err.response.status + " " + err.response.statusText
                  );
                  setLoader(false);
                  props.setShowError(true);
                  props.arrangeBlocks(props.blockJsonArr, err.response.data);
                });
            });
        } else if (Number(props.endMethod) === 3) {
          axios
            .get(
              "https://api.fabloq.com/user/testing/auth/" +
                props.projectId +
                "/",
              {
                headers: {
                  Authorization: localStorage.getItem("token"),
                },
              }
            )
            .then((res) => {
              axios
                .delete(
                  "https://api.fabloq.com/" +
                    props.proName +
                    "/" +
                    props.endPath,
                  {
                    headers: {
                      Authorization: "Bearer " + res.data.token,
                    },
                    data: JSON.parse(props.testBody ? props.testBody : "{}"),
                  }
                )
                .then((res) => {
                  props.setTestResult(JSON.stringify(res.data, null, 2));
                  props.setTestResultStatus(res.status);
                  props.setErrors({ block_id: "" });
                  setLoader(false);
                  props.arrangeBlocks(props.blockJsonArr, { block_id: "" });
                })
                .catch((err) => {
                  props.setTestResult(err.response.data.message);
                  props.setErrors(err.response.data);
                  props.setTestResultStatus(
                    err.response.status + " " + err.response.statusText
                  );
                  setLoader(false);
                  props.setShowError(true);
                  props.arrangeBlocks(props.blockJsonArr, err.response.data);
                });
            });
        }
      } catch (err) {
        props.setTestBodyMessage(err.message);
      }
    }
  };
  return (
    <div className="console-content-testing">
      {Number(props.endMethod) !== 0 ? (
        <div className="console-test">
          <InputLabel>Data</InputLabel>
          <OutlinedInput
            multiline
            rows={5}
            value={props.testBody}
            error={Boolean(props.testBodyMessage)}
            onChange={(e) => {
              // console.log(e.target.value.charAt(e.target.selectionStart - 2));
              // console.log(e.target.value.charAt(e.target.selectionStart + 1));
              // if (
              //   e.target.value.charAt(e.target.selectionStart - 1) === "{" &&
              //   e.target.value.length > testBody.length
              // ) {
              //   setTestBody(e.target.value + "}");

              //   try {
              //     JSON.parse(e.target.value + "}");
              //     setTestBodyMessage("");
              //   } catch (err) {
              //     console.log(err.message);
              //     setTestBodyMessage(err.message);
              //   }
              // } else if (
              //   e.target.value.charAt(e.target.value.length - 1) === '"' &&
              //   e.target.value.length > testBody.length
              // ) {
              //   setTestBody(e.target.value + '"');
              //   try {
              //     JSON.parse(e.target.value + '"');
              //     setTestBodyMessage("");
              //   } catch (err) {
              //     console.log(err.message);
              //     setTestBodyMessage(err.message);
              //   }
              // } else if (
              //   e.target.value.charAt(e.target.selectionStart - 1) === "\n" &&
              //   e.target.value.charAt(e.target.selectionStart + 1) === "}" &&
              //   e.target.value.length > testBody.length
              // ) {
              //   setTestBody(e.target.value + "\t");
              //   try {
              //     JSON.parse(e.target.value + "\t");
              //     setTestBodyMessage("");
              //   } catch (err) {
              //     console.log(err.message);
              //     setTestBodyMessage(err.message);
              //   }
              // } else {
              props.setTestBody(e.target.value);

              // }
            }}
          />
          <FormHelperText error={Boolean(props.testBodyMessage)}>
            {props.testBodyMessage}
          </FormHelperText>
          <Button onClick={() => handleTestSend()}>Send</Button>
        </div>
      ) : (
        <div className="console-test">
          <InputLabel>Data</InputLabel>
          <div className="get-data-container">
            {props.testGetData.map((obj, index) => {
              return (
                <GetKeyValue
                  index={index}
                  key={index}
                  testGetDataErr={props.testGetDataErr}
                  setTestGetDataErr={props.setTestGetDataErr}
                  setTestGetData={props.setTestGetData}
                  testGetData={props.testGetData}
                  setTrig={props.setTrig}
                  trig={props.trig}
                />
              );
            })}
          </div>

          <Button onClick={() => handleTestSend()}>Send</Button>
        </div>
      )}
      <div className="console-result">
        <InputLabel>Result</InputLabel>
        {loader ? (
          <div className="console-display-loader">
            <CircularProgress />
          </div>
        ) : (
          <div className="console-display">
            <pre>{props.testResult}</pre>
          </div>
        )}
        <div className="console-result-status">
          Status: {props.testResultStatus}
        </div>
      </div>
    </div>
  );
};

export const WorkPage = (props) => {
  const [proName, setProName] = useState("");
  const [endpoints, setEndpoints] = useState([]);
  const [proUrl, setProUrl] = useState("");

  const [editEndDialog, setEditEndDialog] = useState(false);
  const [editEnd, setEditEnd] = useState(false);

  const [blockDialog, setBlockDialog] = useState(false);
  const [blockArr, setBlockArr] = useState([]);
  const [blockJsonArr, setBlockJsonArr] = useState([]);

  const [endName, setEndName] = useState("");
  const [endPath, setEndPath] = useState("");
  const [endMethod, setEndMethod] = useState(0);
  const [editEndName, setEditEndName] = useState("");
  const [editEndPath, setEditEndPath] = useState("");
  const [editEndMethod, setEditEndMethod] = useState(0);
  const [endNameErr, setEndNameErr] = useState(false);
  const [endPathErr, setEndPathErr] = useState(false);
  const [endNameErrMessage, setEndNameErrMessage] = useState("");
  const [endPathErrMessage, setEndPathErrMessage] = useState("");

  const [activeEnd, setActiveEnd] = useState(null);
  const [activeBlock, setActiveBlock] = useState(null);
  const [addBlock, setAddBlock] = useState({ id: "", true: null });

  const [bottomConsole, setBottomConsole] = useState(false);

  const [testBody, setTestBody] = useState();
  const [testBodyMessage, setTestBodyMessage] = useState("");
  const [testResult, setTestResult] = useState();
  const [testResultStatus, setTestResultStatus] = useState("");

  const [testGetData, setTestGetData] = useState([{ key: "", value: "" }]);
  const [testGetDataErr, setTestGetDataErr] = useState([
    { key: false, value: false },
  ]);

  const [trig, setTrig] = useState(false);

  const [errors, setErrors] = useState({ block_id: "" });
  const [showError, setShowError] = useState(true);

  const [dbMeta, setDbMeta] = useState(null);

  const [getStarted, setGetStarted] = useState(
    !Boolean(sessionStorage.getItem("getstarted"))
  );

  const methodArr = ["get", "post", "put", "del"];

  let { projectId } = useParams();

  let elCount = 0;

  useEffect(() => {
    axios
      .get(`https://api.fabloq.com/user/project/details/${projectId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setEndpoints(res.data.endpoints);
        setProName(res.data.name);
        setProUrl(res.data.url);
        setDbMeta(res.data.db_meta);
      });
    sessionStorage.setItem("getstarted", true);
  }, []);

  const handleNewEndpoint = () => {
    setEndNameErr(false);
    setEndPathErr(false);
    if (!Boolean(editEndName) || !Boolean(editEndPath)) {
      if (!Boolean(editEndName)) {
        setEndNameErr(true);
        setEndNameErrMessage("Please enter endpoint name.");
      }
      if (!Boolean(editEndPath)) {
        setEndPathErr(true);
        setEndPathErrMessage("Please enter endpoint path.");
      }
      return;
    }
    let data = new FormData();
    data.append("name", editEndName);
    data.append("project", projectId);
    data.append("url_path", editEndPath);
    data.append("method", editEndMethod);

    axios
      .post("https://api.fabloq.com/user/endpoint/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.status === 226) {
          if (res.data.type === "name error") {
            setEndNameErr(true);
            setEndNameErrMessage(res.data.message);
          }
          if (res.data.type === "path error") {
            setEndPathErr(true);
            setEndPathErrMessage(res.data.message);
          }
          return;
        }
        axios
          .get(`https://api.fabloq.com/user/project/details/${projectId}`, {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          })
          .then((res) => {
            setEndpoints(res.data.endpoints);
            setEditEndDialog(false);
            setEndNameErr(false);
            setEndPathErr(false);
            setTestBody("");
            setTestBodyMessage("");
            setTestResult("");
            setTestResultStatus("");
            handleSelectEndpoint(
              res.data.endpoints[res.data.endpoints.length - 1]
            );
            // setEndName("");
            // setEndMethod(0);
            // setEndPath("");
          });
      });
  };

  const handleEditEndpoint = () => {
    setEndNameErr(false);
    setEndPathErr(false);
    if (!Boolean(editEndName) || !Boolean(editEndPath)) {
      if (!Boolean(editEndName)) {
        setEndNameErr(true);
        setEndNameErrMessage("Please enter endpoint name.");
      }
      if (!Boolean(editEndPath)) {
        setEndPathErr(true);
        setEndPathErrMessage("Please enter endpoint path.");
      }
      return;
    }
    let data = new FormData();
    data.append("name", editEndName);
    data.append("endpoint", activeEnd);
    data.append("url_path", editEndPath);
    data.append("method", editEndMethod);

    axios
      .put("https://api.fabloq.com/user/endpoint/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        if (res.status === 226) {
          if (res.data.type === "name error") {
            setEndNameErr(true);
            setEndNameErrMessage(res.data.message);
          }
          if (res.data.type === "path error") {
            setEndPathErr(true);
            setEndPathErrMessage(res.data.message);
          }
          return;
        }
        axios
          .get(`https://api.fabloq.com/user/project/details/${projectId}`, {
            headers: {
              Authorization: localStorage.getItem("token"),
            },
          })
          .then((res) => {
            setEndpoints(res.data.endpoints);
            setEditEndDialog(false);
            setEndName(editEndName);
            setEndMethod(editEndMethod);
            setEndPath(editEndPath);
            setEndNameErr(false);
            setEndPathErr(false);
          });
      });
  };

  const blockRec = (blk, blocks, errors) => {
    if (blk.data.type == "response") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <a
                  href="#"
                  className="block-response-content"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(blk);
                    setBlockDialog(true);
                  }}
                >
                  <p className="block-response-title">Response</p>
                  <p className="block-response-status">
                    {blk.data.body.status}
                  </p>
                </a>
                <IconButton
                  className="block-delete-button"
                  onClick={() => {
                    handleRemoveBlock(blk.id);
                  }}
                >
                  <CloseIcon color="white" />
                </IconButton>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "variable") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Variable</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  <p className="var-name">{blk.data.body.name}</p>
                  <p className="var-value">{blk.data.body.value}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "if") {
      let trueTempArr = [];
      let falseTempArr = [];

      let block = null;
      let next_id = null;

      for (let i = 0; i < blocks.length; i++) {
        // find get first true block
        if (blocks[i].id === blk.data.next.true) {
          block = blocks[i];
          next_id = block.data.next;
          if (block.data.type === "if" || block.data.type === "loop") {
            next_id = "";
          }
          break;
        }
      }

      if (block) {
        let res = blockRec(block, blocks, errors);
        trueTempArr.push(res.block);
      }

      while (next_id) {
        for (let i = 0; i < blocks.length; i++) {
          // find next block
          if (blocks[i].id === next_id) {
            block = blocks[i];
            next_id = block.data.next;
            if (block.data.type === "if" || block.data.type === "loop") {
              next_id = "";
            }
            break;
          }
        }
        let res = blockRec(block, blocks, errors);
        trueTempArr.push(res.block);
      }

      block = null;
      next_id = null;

      for (let i = 0; i < blocks.length; i++) {
        // find get first false block
        if (blocks[i].id === blk.data.next.false) {
          block = blocks[i];
          next_id = block.data.next;
          if (block.data.type === "if" || block.data.type === "loop") {
            next_id = "";
          }
          break;
        }
      }

      if (block) {
        let res = blockRec(block, blocks, errors);
        falseTempArr.push(res.block);
      }

      while (next_id) {
        for (let i = 0; i < blocks.length; i++) {
          // find next block
          if (blocks[i].id === next_id) {
            block = blocks[i];
            next_id = block.data.next;
            if (block.data.type === "if" || block.data.type === "loop") {
              next_id = "";
            }
            break;
          }
        }
        let res = blockRec(block, blocks, errors);
        falseTempArr.push(res.block);
      }

      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="if-block"
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">IF</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  <p className="var-value">{blk.data.body.condition}</p>
                </div>
                <div className="var-block-content">
                  <p className="var-name">True</p>
                  <p className="var-name">False</p>
                </div>
              </div>
            </Tooltip>
            <div className="two-line">
              <div className="line-container">
                <div className="line" />
                {!blk.data.next.true ? (
                  <a
                    href="#"
                    className="block-add"
                    onClick={(e) => {
                      e.preventDefault();
                      setAddBlock({ id: blk.id, true: true });
                      setActiveBlock(null);
                      setBlockDialog(true);
                    }}
                  >
                    <AddIcon color="primary" />
                  </a>
                ) : (
                  ""
                )}
              </div>

              <div className="line-container">
                <div className="line" />
                {!blk.data.next.false ? (
                  <a
                    href="#"
                    className="block-add"
                    onClick={(e) => {
                      e.preventDefault();
                      setAddBlock({ id: blk.id, true: false });
                      setActiveBlock(null);
                      setBlockDialog(true);
                    }}
                  >
                    <AddIcon color="primary" />
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="if-container">
              <div className="if-line-container">
                {blk.data.next.true ? (
                  <div className="if-line-true">
                    <div className="if-line-left" />
                    <div className="if-line-mid" />
                    <div className="if-line-right" />
                  </div>
                ) : (
                  <div className="if-line-true" />
                )}
                {blk.data.next.false ? (
                  <div className="if-line-false">
                    <div className="if-line-right" />
                    <div className="if-line-mid" />
                    <div className="if-line-left" />
                  </div>
                ) : (
                  <div className="if-line-true" />
                )}
              </div>
              <div className="if-conditions">
                <div className="if-true">
                  {trueTempArr.map((obj, index) => {
                    return obj;
                  })}
                </div>
                <div className="if-false">
                  {falseTempArr.map((obj, index) => {
                    return obj;
                  })}
                </div>
              </div>
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "loop") {
      let trueTempArr = [];
      let falseTempArr = [];

      let block = null;
      let next_id = null;

      for (let i = 0; i < blocks.length; i++) {
        // find get first true block
        if (blocks[i].id === blk.data.next.true) {
          block = blocks[i];
          next_id = block.data.next;
          if (block.data.type === "if" || block.data.type === "loop") {
            next_id = "";
          }
          break;
        }
      }

      if (block) {
        let res = blockRec(block, blocks, errors);
        trueTempArr.push(res.block);
      }

      while (next_id) {
        for (let i = 0; i < blocks.length; i++) {
          // find next block
          if (blocks[i].id === next_id) {
            block = blocks[i];
            next_id = block.data.next;
            if (block.data.type === "if" || block.data.type === "loop") {
              next_id = "";
            }
            break;
          }
        }
        let res = blockRec(block, blocks, errors);
        trueTempArr.push(res.block);
      }

      block = null;
      next_id = null;

      for (let i = 0; i < blocks.length; i++) {
        // find get first false block
        if (blocks[i].id === blk.data.next.false) {
          block = blocks[i];
          next_id = block.data.next;
          if (block.data.type === "if" || block.data.type === "loop") {
            next_id = "";
          }
          break;
        }
      }

      if (block) {
        let res = blockRec(block, blocks, errors);
        falseTempArr.push(res.block);
      }

      while (next_id) {
        for (let i = 0; i < blocks.length; i++) {
          // find next block
          if (blocks[i].id === next_id) {
            block = blocks[i];
            next_id = block.data.next;
            if (block.data.type === "if" || block.data.type === "loop") {
              next_id = "";
            }
            break;
          }
        }
        let res = blockRec(block, blocks, errors);
        falseTempArr.push(res.block);
      }

      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="if-block"
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Loop</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  <p className="var-value">{blk.data.body.condition}</p>
                </div>
                <div className="var-block-content">
                  <p className="var-name">True</p>
                  <p className="var-name">False</p>
                </div>
              </div>
            </Tooltip>
            <div className="two-line">
              <div className="line-container">
                <div className="line" />
                {!blk.data.next.true ? (
                  <a
                    href="#"
                    className="block-add"
                    onClick={(e) => {
                      e.preventDefault();
                      setAddBlock({ id: blk.id, true: true });
                      setActiveBlock(null);
                      setBlockDialog(true);
                    }}
                  >
                    <AddIcon color="primary" />
                  </a>
                ) : (
                  ""
                )}
              </div>

              <div className="line-container">
                <div className="line" />
                {!blk.data.next.false ? (
                  <a
                    href="#"
                    className="block-add"
                    onClick={(e) => {
                      e.preventDefault();
                      setAddBlock({ id: blk.id, true: false });
                      setActiveBlock(null);
                      setBlockDialog(true);
                    }}
                  >
                    <AddIcon color="primary" />
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="if-container">
              <div className="if-line-container">
                {blk.data.next.true ? (
                  <div className="if-line-true">
                    <div className="if-line-left" />
                    <div className="if-line-mid" />
                    <div className="if-line-right" />
                  </div>
                ) : (
                  <div className="if-line-true" />
                )}
                {blk.data.next.false ? (
                  <div className="if-line-false">
                    <div className="if-line-right" />
                    <div className="if-line-mid" />
                    <div className="if-line-left" />
                  </div>
                ) : (
                  <div className="if-line-true" />
                )}
              </div>
              <div className="if-conditions">
                <div className="if-true">
                  {trueTempArr.map((obj, index) => {
                    return obj;
                  })}
                </div>
                <div className="if-false">
                  {falseTempArr.map((obj, index) => {
                    return obj;
                  })}
                </div>
              </div>
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "dbfilter") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Database Fetch Many</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  {/* <p className="var-name">{blk.data.body.var_name}</p> */}
                  <p className="var-value">{blk.data.body.var_name}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "dbget") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Database Fetch One</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  {/* <p className="var-name">{blk.data.body.var_name}</p> */}
                  <p className="var-value">{blk.data.body.var_name}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "dbcreate") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Database Create</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  {/* <p className="var-name">{blk.data.body.var_name}</p> */}
                  <p className="var-value">{blk.data.body.var_name}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "dbupdate") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Database Update</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  {/* <p className="var-name">{blk.data.body.var_name}</p> */}
                  <p className="var-value">{blk.data.body.var_name}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "dbdelete") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Database Delete</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  {/* <p className="var-name">{blk.data.body.var_name}</p> */}
                  <p className="var-value">{blk.data.body.var_name}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "codepy") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <a
                  href="#"
                  className="block-response-content"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(blk);
                    setBlockDialog(true);
                  }}
                >
                  <p className="block-response-title">Python Script</p>
                  <p className="block-response-status"></p>
                </a>
                <IconButton
                  className="block-delete-button"
                  onClick={() => {
                    handleRemoveBlock(blk.id);
                  }}
                >
                  <CloseIcon color="white" />
                </IconButton>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "authsignup") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <a
                  href="#"
                  className="block-response-content"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <p className="block-response-title"> User Signup</p>
                  <p className="block-response-status"></p>
                </a>
                <IconButton
                  className="block-delete-button"
                  onClick={() => {
                    handleRemoveBlock(blk.id);
                  }}
                >
                  <CloseIcon color="white" />
                </IconButton>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "authsignin") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <a
                  href="#"
                  className="block-response-content"
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                >
                  <p className="block-response-title"> User Sign In</p>
                  <p className="block-response-status"></p>
                </a>
                <IconButton
                  className="block-delete-button"
                  onClick={() => {
                    handleRemoveBlock(blk.id);
                  }}
                >
                  <CloseIcon color="white" />
                </IconButton>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "datetimevar") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">Date Time</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  <p className="var-name">{blk.data.body.var_name}</p>
                  <p className="var-value">
                    {blk.data.body.dtvaluetype === "0" ? "Now" : "Custom"}
                  </p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    } else if (blk.data.type == "jsontodatetime") {
      return {
        next: blk.data.next,
        block: (
          <div className="block-container" key={blk.id}>
            <Tooltip
              title={errors.block_id === blk.id ? errors.message : ""}
              placement="right"
              arrow
              open={showError}
              onClose={() => {
                setShowError(false);
              }}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <div
                className="var-block"
                key={blk.id}
                style={
                  errors.block_id === blk.id
                    ? { border: "2px solid #9d3030" }
                    : { border: "none" }
                }
              >
                <div className="var-block-header">
                  <a
                    href="#"
                    className="block-response-content"
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveBlock(blk);
                      setBlockDialog(true);
                    }}
                  >
                    <p className="block-response-title">JSON to Date Time</p>
                  </a>
                  <IconButton
                    className="block-delete-button"
                    onClick={() => {
                      handleRemoveBlock(blk.id);
                    }}
                  >
                    <CloseIcon color="white" />
                  </IconButton>
                </div>
                <div className="var-block-content">
                  <p className="var-name">{blk.data.body.name}</p>
                  <p className="var-value">{blk.data.body.value}</p>
                </div>
              </div>
            </Tooltip>
            <div className="line-container">
              <div className="line" />
              {!blk.data.next ? (
                <a
                  href="#"
                  className="block-add"
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveBlock(null);
                    setBlockDialog(true);
                    setAddBlock({ id: blk.id, true: null });
                  }}
                >
                  <AddIcon color="primary" />
                </a>
              ) : (
                ""
              )}
            </div>
          </div>
        ),
      };
    }
  };

  const arrangeBlocks = (blocks, errors) => {
    let tempArr = [];
    let block = null;
    let next_id = null;

    for (let i = 0; i < blocks.length; i++) {
      // find first block
      if (!blocks[i].data.prev) {
        block = blocks[i];
        next_id = block.data.next;
        if (block.data.type === "if" || block.data.type === "loop") {
          next_id = "";
        }
        break;
      }
    }
    if (!block) {
      // terminate function if no first block
      setBlockArr([]);
      return;
    }
    let res = blockRec(block, blocks, errors);
    next_id = res.next;
    if (block.data.type === "if" || block.data.type === "loop") {
      next_id = "";
    }
    tempArr.push(res.block);

    while (next_id) {
      for (let i = 0; i < blocks.length; i++) {
        // find next block
        if (blocks[i].id === next_id) {
          block = blocks[i];
          next_id = block.data.next;
          if (block.data.type === "if" || block.data.type === "loop") {
            next_id = "";
          }
          break;
        }
      }
      let res = blockRec(block, blocks, errors);
      next_id = res.next;
      if (block.data.type === "if" || block.data.type === "loop") {
        next_id = "";
      }
      tempArr.push(res.block);
    }
    setBlockArr(tempArr);
  };

  const handleSelectEndpoint = (obj) => {
    setActiveEnd(obj.id);
    setBlockArr([]);
    const workspace = document.getElementById("work-page-workspace");
    workspace.scrollLeft =
      workspace.scrollWidth / 2 - workspace.offsetWidth / 2;
    workspace.scrollTop = 0;

    axios
      .get(`https://api.fabloq.com/user/endpoint/${obj.id}/`, {
        headers: { Authorization: localStorage.getItem("token") },
      })
      .then((res) => {
        setBlockJsonArr(res.data.blocks);
        setEndPath(res.data.url_path);
        setEndName(res.data.name);
        setEndMethod(res.data.method);
        setTestBody("");
        setTestBodyMessage("");
        setTestResult("");
        setTestResultStatus("");
        setTestGetData([{ key: "", value: "" }]);
        arrangeBlocks(res.data.blocks, errors);
      });
  };

  const handleRemoveBlock = (id) => {
    axios
      .delete("https://api.fabloq.com/user/block/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: {
          id: id,
        },
      })
      .then((res) => {
        arrangeBlocks(res.data.blocks, errors);
        setBlockJsonArr(res.data.blocks);
        setTrig(!trig);
      });
  };

  const handleDeleteEndpoint = (id) => {
    axios
      .delete("https://api.fabloq.com/user/endpoint/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: {
          endpoint: id,
        },
      })
      .then((res) => {
        setEndpoints(res.data.endpoints);
        setActiveEnd(null);
      });
  };

  return (
    <div className="work-page">
      <Dialog
        open={editEndDialog}
        onClose={() => {
          setEditEndDialog(false);
        }}
      >
        <DialogTitle>
          {editEnd ? "Edit Endpoint" : "Create New Endpoint"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Endpoint Name"
            fullWidth
            variant="standard"
            value={editEndName}
            onChange={(e) => {
              setEditEndName(e.target.value);
            }}
            error={endNameErr}
            helperText={endNameErr ? endNameErrMessage : ""}
          />
          <FormControl fullWidth className="text-input-margin-top">
            <InputLabel>Method</InputLabel>
            <Select
              value={editEndMethod}
              label="Method"
              onChange={(e) => setEditEndMethod(e.target.value)}
            >
              <MenuItem value={0}>GET</MenuItem>
              <MenuItem value={1}>POST</MenuItem>
              <MenuItem value={2}>PUT</MenuItem>
              <MenuItem value={3}>DELETE</MenuItem>
            </Select>
          </FormControl>
          <TextField
            autoFocus
            label="Endpoint URL Path"
            fullWidth
            variant="standard"
            value={editEndPath}
            className="text-input-margin-top"
            onChange={(e) => {
              setEditEndPath(e.target.value);
            }}
            error={endPathErr}
            helperText={endPathErr ? endPathErrMessage : ""}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setEditEndDialog(false);
              setEndNameErr(false);
              setEndPathErr(false);
            }}
          >
            Cancel
          </Button>
          <Button
            className="endpoint-submit-button"
            onClick={() => {
              if (editEnd) handleEditEndpoint();
              else handleNewEndpoint();
            }}
          >
            {editEnd ? "Save" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={blockDialog}
        onClose={() => {
          setBlockDialog(false);
        }}
        className="new-block-dialog"
      >
        <NewBlock
          setBlockArr={setBlockArr}
          blockArr={blockArr}
          setBlockDialog={setBlockDialog}
          activeEnd={activeEnd}
          blockJsonArr={blockJsonArr}
          setBlockJsonArr={setBlockJsonArr}
          activeBlock={activeBlock}
          setActiveBlock={setActiveBlock}
          arrangeBlocks={arrangeBlocks}
          addBlock={addBlock}
          errors={errors}
          dbMeta={dbMeta}
        />
      </Dialog>
      <Dialog
        open={getStarted}
        onClose={() => {
          setGetStarted(false);
        }}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle variant="h5">Get Started</DialogTitle>
        <DialogContent className="getstarted-dialog-content">
          <div className="get-started-left">
            <Typography variant="h6" gutterBottom>
              Quick start video
            </Typography>
            <Typography variant="body2" gutterBottom>
              Start using Fabloq quickly with this quick video demo.
            </Typography>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/foCH0x0ehTo?si=HL1s9Z0vkGdAK5eZ"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <div className="get-started-right">
            <Typography variant="h6" gutterBottom>
              Tutorial playlist
            </Typography>
            <Typography variant="body2" gutterBottom>
              Watch our full tutorial series of Fabloq on Youtube{" "}
              <a
                className="getstarted-link"
                href="https://youtube.com/playlist?list=PLoJ5_0_7j5bWqMkBVJwgFD2G9Pb7sD6zI&si=Zz5b2KQoxf7dhXaq"
                target="_blank"
              >
                here.
              </a>
            </Typography>
            <Typography variant="h6" gutterBottom style={{ marginTop: "3rem" }}>
              Documentation
            </Typography>
            <Typography variant="body2" gutterBottom>
              Read the documentation{" "}
              <a
                href="https://www.fabloq.com/docs/"
                className="getstarted-link"
                target="_blank"
              >
                here.
              </a>
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="link"
            onClick={() => {
              setGetStarted(false);
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <div className="topbar">
        <div className="topbar-logo">
          <Link to={"/"}>
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="logo-block"></div>
            </div>
          </Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/workspace/" + projectId}>Workspace</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/database/" + projectId}>Database</Link>
        </div>
        <div className="topbar-tool">
          <Link to={"/dashboard/" + projectId}>Dashboard</Link>
        </div>
      </div>
      <div className="work-page-content">
        <div className="work-page-sidebar">
          <div className="work-page-sidebar-project">
            <p className="work-page-sidebar-label">Project Name</p>
            <p className="work-page-sidebar-project-name">{proName}</p>
          </div>
          <div className="work-page-sidebar-endpoints">
            <p className="work-page-sidebar-label">Endpoints</p>
            <Tooltip title="Add new endpoint">
              <a
                href="#"
                className="add-endpoint-card"
                onClick={(e) => {
                  e.preventDefault();
                  setEditEndDialog(true);
                  setEditEnd(false);
                  setEditEndName("");
                  setEditEndPath("");
                  setEditEndMethod("0");
                  setEndNameErr(false);
                  setEndPathErr(false);
                }}
              >
                <AddIcon color="primary" />
              </a>
            </Tooltip>
            {endpoints.map((obj, index) => {
              return (
                <a
                  className={`endpoint-card ${
                    activeEnd === obj.id ? "endpoint-card-active" : ""
                  }`}
                  href="#"
                  key={obj.id}
                  onClick={(e) => {
                    e.preventDefault();
                    handleSelectEndpoint(obj);
                  }}
                >
                  <div
                    className={`endpoint-type ${methodArr[Number(obj.method)]}`}
                  >
                    {methodArr[Number(obj.method)]}
                  </div>
                  <p>{obj.name}</p>
                </a>
              );
            })}
          </div>
        </div>
        <div className="workspace-container">
          {activeEnd ? (
            <div className="workspace-topbar">
              <div className="workspace-topbar-props">
                <div className="endpoint-chip">
                  <p className="endpoint-title">URL:</p>
                  <p className="endpoint-url">{proUrl + endPath}</p>
                  <Tooltip title="Copy">
                    <IconButton
                      className="endpoint-button"
                      onClick={() => {
                        let url = proUrl + endPath;
                        window.navigator.clipboard.writeText(url);
                      }}
                    >
                      <ContentCopyIcon fontSize="14px" />
                    </IconButton>
                  </Tooltip>
                </div>
                <div className="endpoint-chip">
                  <p className="endpoint-title">Method:</p>
                  <p className="endpoint-url">
                    {methodArr[endMethod].toUpperCase()}
                  </p>
                </div>
              </div>
              <div className="workspace-topbar-actions">
                <div className="endpoint-chip">
                  <p className="endpoint-title">Actions:</p>
                  <Tooltip title="Edit Endpoint">
                    <IconButton
                      className="endpoint-button"
                      onClick={() => {
                        setEditEndDialog(true);
                        setEditEnd(true);
                        setEditEndName(endName);
                        setEditEndPath(endPath);
                        setEditEndMethod(endMethod);
                        setEndNameErr(false);
                        setEndPathErr(false);
                      }}
                    >
                      <EditIcon fontSize="14px" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Endpoint">
                    <IconButton
                      className="endpoint-action-delete"
                      onClick={() => {
                        handleDeleteEndpoint(activeEnd);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="work-page-workspace" id="work-page-workspace">
            <div className="workspace-content" id="workspace-content">
              {activeEnd ? (
                <div className="block-container">
                  <div className="request-block"></div>
                  <div className="line" />

                  {!Boolean(blockArr.length) ? (
                    <Tooltip title="Add code block">
                      <a
                        href="#"
                        className="block-add"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveBlock(null);
                          setBlockDialog(true);
                          setAddBlock({ id: "", true: null });
                        }}
                      >
                        <AddIcon color="primary" />
                      </a>
                    </Tooltip>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                ""
              )}
              {blockArr.map((obj, index) => {
                return obj;
              })}
            </div>
          </div>
          {activeEnd ? (
            <div className="bottom-console">
              <div className="bottom-console-topbar">
                <p>Console</p>
                <div className="bottom-console-topbar-minimize">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setBottomConsole(!bottomConsole);
                    }}
                  >
                    {bottomConsole ? (
                      <KeyboardDoubleArrowDownIcon />
                    ) : (
                      <KeyboardDoubleArrowUpIcon />
                    )}
                  </IconButton>
                </div>
              </div>
              {bottomConsole ? (
                <div className="bottom-console-content">
                  <div className="bottom-console-tabs">
                    {/* <a href="#" className="bottom-console-tab">
                      Logs
                    </a> */}
                    <a href="#" className="bottom-console-tab">
                      Testing
                    </a>
                  </div>
                  <Console
                    testBody={testBody}
                    setTestBody={setTestBody}
                    setTestBodyMessage={setTestBodyMessage}
                    setTestResult={setTestResult}
                    testResult={testResult}
                    testBodyMessage={testBodyMessage}
                    testResultStatus={testResultStatus}
                    setTestResultStatus={setTestResultStatus}
                    endMethod={endMethod}
                    endPath={endPath}
                    proName={proName}
                    testGetData={testGetData}
                    setTestGetData={setTestGetData}
                    testGetDataErr={testGetDataErr}
                    setTestGetDataErr={setTestGetDataErr}
                    setTrig={setTrig}
                    trig={trig}
                    projectId={projectId}
                    setErrors={setErrors}
                    arrangeBlocks={arrangeBlocks}
                    blockJsonArr={blockJsonArr}
                    errors={errors}
                    setShowError={setShowError}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
